import { render, staticRenderFns } from "./DaKuan.vue?vue&type=template&id=54a768e8&scoped=true&"
import script from "./DaKuan.vue?vue&type=script&lang=js&"
export * from "./DaKuan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54a768e8",
  null
  
)

export default component.exports